import axios from 'axios'
import APIConfig from '../remote/APIConfig.js'
import Config from '@/assets/js/config.js'

export default class AuthService {
  constructor (passwordCrypter) {
    this.passwordCrypter = passwordCrypter
    this.apis = {
      login: payload => axios.post(APIConfig.BPIURL + '/login', payload),
      refresh: payload => axios.post(APIConfig.BPIURL + '/refresh', payload)
    }
  }

  getJWT () {
    return localStorage.getItem(Config.jwtStorageKey)
  }

  isJWTValid (jwt) {
    try {
      let jwtArr = jwt.split('.')
      let exp = JSON.parse(atob(jwtArr[1])).exp
      if (exp) return true
    } catch (err) {
      console.error(err)
    }
    return false
  }

  saveJWT (jwt) {
    localStorage.setItem(Config.jwtStorageKey, jwt)
  }

  isLogined (vm) {
    let jwt = this.getJWT()
    if (!jwt) return false
    return this.isJWTValid(jwt)
  }

  logout (vm) {
    localStorage.removeItem(Config.jwtStorageKey)
  }

  login (vm, params) {
    vm.isLoading = true
    params.password = this.passwordCrypter.cryptPassword(params.password)
    return this.apis.login(params)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (ok) {
            let token = res.data.result
            this.saveJWT(token)
            axios.defaults.headers['Authorization'] = `Bearer ${token}`
          } else {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return ok
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  refresh (vm) {
    vm.isLoading = true
    let params = {}
    return this.apis.refresh(params)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (ok) {
            let token = res.data.result
            this.saveJWT(token)
            axios.defaults.headers['Authorization'] = `Bearer ${token}`
          } else {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return ok
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
